import React from 'react'

export default function Container(props) {
  const divContainer = {
    margin: ' 10px 1rem 10px 1rem',
  }

  return <div style={divContainer}>{props.children}</div>
}
